import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { CheckoutComponent } from './layouts/checkout/checkout.component';
import { HomeComponent } from './home/home.component';
import { MainComponent } from './layouts/main/main.component';
import { OpenpayFormComponent } from './layouts/checkout/openpay/openpay-form.component';
import { PaynetFormComponent } from './layouts/checkout/paynet/paynet-form.component';
import { PrivacyNoticesComponent } from 'src/app/layouts/pages/privacy-notices/privacy-notices.component';
import { ResetPasswordComponent } from './user-access/resetPassword/reset-password.component';
import { SpeiFormComponent } from './layouts/checkout/spei/spei-form.component';
import { SuccessfulPurchaseComponent } from './layouts/checkout/openpay/successful-purchase/successful-purchase.component';
import { CustomerPermissionsGuard } from 'Guards/customer-permissions.guard';
import { PaylinkFormComponent } from './layouts/checkout/paylink/paylink-form.component';
import { CardpayFormComponent } from './layouts/checkout/cardpay/cardpay-form.component';
import { ImageComponent } from 'src/app/layouts/pages/image/image.component';
import { CheckoutPendingPaymentComponent } from './layouts/checkout/checkout-pending-payment/checkout-pending-payment.component';

const routes: Routes = [
  {
    path: '',
    component: MainComponent,
    children: [
      {
        path: '',
        component: HomeComponent,
      },
      {
        path: 'img',
        component: ImageComponent,
      },
      {
        path: 'avisos-privacidad',
        component: PrivacyNoticesComponent,
      },
      {
        path: 'mis-casos',canActivate:[CustomerPermissionsGuard],
        loadChildren: () => import('./catalogs/cases/case.module').then(m => m.CaseModule)
      },
      {
        path: 'tienda', canActivate:[CustomerPermissionsGuard],
        loadChildren: () => import('./catalogs/products/product.module').then(m => m.ProductModule)
      },
      {
        path: 'mi-perfil',canActivate:[CustomerPermissionsGuard],
        loadChildren: () => import('./catalogs/customers/customer.module').then(m => m.CustomerModule)
      },
      {
        path: "mis-compras",canActivate:[CustomerPermissionsGuard],
        loadChildren: () => import("./catalogs/orders/order.module").then(m => m.OrderModule)
      },
      {
        path: "mis-productos",canActivate:[CustomerPermissionsGuard],
        loadChildren: () => import("./catalogs/customer-stock/customer-stock.module").then(m => m.CustomerStockModule)
      },
      {
        path: "mis-solicitudes-smart-stl",canActivate:[CustomerPermissionsGuard],
        loadChildren: () => import("./catalogs/smart-stl-requests/smart-stl-requests.module").then(m => m.SmartStlRequestsModule)
      },
      {
        path: "checkout",
        component: CheckoutComponent,
      },
      {
        path: "checkout-pending-payment",
        component: CheckoutPendingPaymentComponent,
      },
      {
        path: "openpay",
        component: OpenpayFormComponent,
      },
      {
        path: "compra-completada",
        component: SuccessfulPurchaseComponent
      },
      {
        path: "paynet",
        component: PaynetFormComponent,
      },
      {
        path: "spei",
        component: SpeiFormComponent,
      },
      {
        path: "paylink",
        component: PaylinkFormComponent,
      },
      {
        path: "cardpay",
        component: CardpayFormComponent,
      },
      {
        path: "resetpassword",
        component: ResetPasswordComponent,
      }
    ]
  },
  {
    path: "",
    redirectTo: '/ecommerce'
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class AppClientRoutingModule { }
